/**
 * Get a sorted list of plugins. This is used to control order of elements in the UI.
 * Functionality shouldn't assume order.
 * @param {Object} where object values are the plugins to sort
 * @return {Oskari.mapframework.ui.module.common.mapmodule.Plugin[]} index ordered list of registered plugins
 */
export var getSortedPlugins = function getSortedPlugins() {
  var pluginInstances = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var plugins = Object.values(pluginInstances);
  plugins.sort(function (a, b) {
    return getPluginIndex(a) - getPluginIndex(b);
  });
  return plugins;
};
var getPluginIndex = function getPluginIndex(plugin) {
  if (typeof (plugin === null || plugin === void 0 ? void 0 : plugin.getIndex) !== 'function') {
    // index not defined, start after ones that have indexes
    // This is just for the UI order, functionality shouldn't assume order
    return 99999999999;
  }
  return plugin.getIndex();
};
export var getPluginsWithUI = function getPluginsWithUI() {
  var pluginInstances = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var plugins = getSortedPlugins(pluginInstances);
  return plugins.filter(function () {
    var plugin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (typeof plugin.hasUI === 'function') {
      return plugin.hasUI();
    }
    return false;
  });
};
export var refreshPluginsWithUI = function refreshPluginsWithUI() {
  var pluginInstances = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return getPluginsWithUI(pluginInstances).forEach(function (plugin) {
    if (typeof plugin.refresh === 'function') {
      plugin.refresh();
    }
  });
};
export var resetPluginsWithUI = function resetPluginsWithUI() {
  var pluginInstances = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return getPluginsWithUI(pluginInstances).forEach(function (plugin) {
    if (typeof plugin.resetUI === 'function') {
      // TODO: is this the function that we should use?
      plugin.resetUI();
    }
  });
};